module.exports = __webpack_public_path__ + "static/img/1805_3.c3f528b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1805_3.jpg
// module id = dPSI
// module chunks = 1